module.exports = require("./wo.js");